export default __webpack_public_path__ + "static/media/elle.f5c4c5d8.bin";